import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';

import {Navigate} from 'react-router';

import SpinnerWithOverlay from 'shared/ui/SpinnerWithOverlay/SpinnerWithOverlay';

import {AppUrls} from 'shared/config/model/urls';

import {getAccessToken, getRefreshToken} from 'shared/api/auth';

import {Permission} from '../../model/Permission';
import {userPermissionsSelector, userSelector} from '../../model/authSlice';
import {isGrantedAccess} from '../../lib/permissionsHelper';
import NoAuth from './NoAuth';


interface IProtectedElementProps {
    element: ReactElement,
    auth: Permission[],
}

const ProtectedElement: React.FC<IProtectedElementProps> = ({element, auth}) => {
    const user = useSelector(userSelector);
    const userPermissions = useSelector(userPermissionsSelector);
    const hasTokens = !!getAccessToken() || !!getRefreshToken();

    if (hasTokens && user === null) {
        return <SpinnerWithOverlay />;
    }

    if (!hasTokens && user === null) {
        return <Navigate to={AppUrls.LOGIN} replace />;
    }

    return isGrantedAccess(userPermissions, auth)
        ? element
        : <NoAuth />;
};

export default ProtectedElement;